import { Component, type ReactNode } from 'react';

interface Props {
  children: ReactNode;
  fallback?: (error: Error) => ReactNode;
}

interface State {
  error: Error | null;
}

export class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error, info: { componentStack: string }) {
    console.error('[ErrorBoundary] Render error:', error, info.componentStack);
  }

  reset = () => this.setState({ error: null });

  render() {
    const { error } = this.state;
    if (error) {
      if (this.props.fallback) return this.props.fallback(error);
      return (
        <div role="alert" className="app-error-state">
          <div className="app-error-shell">
            <p className="app-error-eyebrow">Something went wrong</p>
            <p className="app-error-copy">
              This view hit a render problem. Retry it or go back to the dashboard.
            </p>
            <div className="app-error-actions">
              <button onClick={this.reset} className="app-error-button">
                Retry
              </button>
              <a href="#/dashboard" className="app-error-link">
                Dashboard
              </a>
            </div>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
